import React from 'react';
import { getLabels, getValues } from '../../../utils/chart-utils';
import Chart from '../../common/charts/Chart';
import NoDataAvailable from '../../common/charts/NoDataAvailable';
import PropTypes from 'prop-types';

const DashboardChartWrapper = ({ chart, reports, languageState, oneWeek }) => {
  
  if (chart && reports && reports.length > 0) {
    return (
      <Chart chartData={chart.valueFields && chart.labelFields &&
      {
        ...chart,
        values: getValues(chart.valueFields, reports),
        labels: getLabels(chart.labelFields, reports, languageState, oneWeek),
      }}
             dashboardChart
      />
    );
  }
  
  return <NoDataAvailable />;
};

DashboardChartWrapper.propTypes = {
  chart: PropTypes.object,
  reports: PropTypes.array,
  languageState: PropTypes.string,
  oneWeek: PropTypes.bool,
};

export default DashboardChartWrapper;